import React from 'react'

export default function NoTengo() {
	return (
		<div class='row notengo-content'>
			<div class='notengo-wrapper bicflex'>
				<img width='40%' src={`${process.env.PUBLIC_URL}/images/404.svg`} />
			</div>
			<a class='text-center link' href='#/dashboard'>Hitta hem</a>
		</div>
	)
}
